export default __webpack_public_path__ + "static/media/gallery-wip-grenade_08.175fac60.jpg";